import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PdfExportEffects } from './pdf-export.effects';
import * as reducers from './pdf-export.reducer';

@NgModule({
  imports: [
    EffectsModule.forFeature([PdfExportEffects]),
    StoreModule.forFeature('pdfExport', reducers.pdfExportReducer),
  ],
})
export class PdfExportDomainModule {}
